<template>
    <section>
        <canvas ref="barChart"></canvas>
    </section>
</template>

<script>
    import Chart from 'chart.js'

    export default {
        name: 'TotalBarChart',
        props: {
            data: {
                default: () => [],
                type: Array
            },
            label: {
                default: '',
                type: String
            },
            backgroundColor: {
                default: 'rgba(94, 180, 8, 0.5)',
                type: String
            },
            borderColor: {
                default: 'rgba(94, 180, 8, 1)',
                type: String
            },
            allowDecimals: {
                default: true,
                type: Boolean
            }
        },
        data () {
            return {
                barChart: null
            }
        },
        watch: {
            data (data) {
                this.drawBarChart()
            }
        },
        methods: {
            drawBarChart () {
                const ctx = this.$refs.barChart
                this.barChart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: this.data.map(x => x[0]),
                        datasets: [
                            {
                                label: this.label,
                                backgroundColor: this.backgroundColor,
                                borderColor: this.borderColor,
                                data: this.data.map(x => x[1])
                            }
                        ]
                    },
                    options: {
                        legend: {
                            display: false
                        },
                        // tooltips: {
                        //     callbacks: {
                        //         label: (tooltipItems, data) => {
                        //             return data.datasets[tooltipItems.datasetIndex].label + ': ' + tooltipItems.xLabel
                        //         }
                        //     }
                        // },
                        scales: {
                            xAxes: [{
                                ticks: {
                                    userCallback: (item) => {
                                        return item
                                    }
                                }
                            }],
                            yAxes: [{
                                ticks: {
                                    // Include a dollar sign in the ticks
                                    callback: function(value) {
                                        if (this.allowDecimals) {
                                            return value
                                        } else {
                                            return Math.floor(value * 10) % 10 === 0 ? value : ''
                                        }
                                    }
                                }
                            }]
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
